// removed by extract-text-webpack-plugin
module.exports = {"user-profile-form-wrapper":"user-profile-form-wrapper","userProfileFormWrapper":"user-profile-form-wrapper","form-validation-message-wrapper":"form-validation-message-wrapper","formValidationMessageWrapper":"form-validation-message-wrapper","edit-profile-sucess-message":"edit-profile-sucess-message","editProfileSucessMessage":"edit-profile-sucess-message"};


//////////////////
// WEBPACK FOOTER
// ./src/components/users/editUserProfile/style.scss
// module id = 458
// module chunks = 0